

















































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import { ProfileFileType, ROLES } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseMenu from "@/components/BaseMenu";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";
import ProfileHeaderAvatar from "@/components/ProfileHeaderAvatar";
import ProfileHeaderBackground from "@/components/ProfileHeaderBackground";
import UserAvatarController from "@/components/UserPictures/UserAvatarController";
import UserBackgroundController from "@/components/UserPictures/UserBackgroundController";

export default defineComponent({
  name: "UserPictures",
  components: {
    BaseMenu,
    UserAvatarController,
    ModalView,
    UserBackgroundController,
    ProfileHeaderBackground,
    BaseSpinner,
    ProfileHeaderAvatar,
    BaseIcon,
    BaseButton,
  },
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup(props) {
    const menuItems = computed<BaseMenuItem[]>(() => [
      { name: "new", text: $t("Upload new") },
      { name: "delete", text: $t("Delete"), class: "negative" },
    ]);

    const showChangeAvatar = ref(false);
    const showChangeBanner = ref(false);

    const isUserCreator = computed(() => checkRole(props.user?.role ?? "", [ROLES.CREATOR, ROLES.FULL_CREATOR]));

    return {
      showChangeAvatar,
      showChangeBanner,
      menuItems,
      isUserCreator,
      ProfileFileType,
    };
  },
});
